<template>
  <section class="w-full">
    <section
      class="flex flex-col items-center justify-center lg:py-4 lg:flex-row lg:justify-between lg:px-4 lg:max-w-5xl lg:mx-auto"
    >
      <section class="flex-1 px-10 mb-2 lg:mb-0 order-2" :class="{ 'lg:order-2': info.side === 'left' }">
        <p class="text-2xl font-bold mb-4" v-text="info.title" />
        <p class="font-light" v-html="info.description" />
      </section>
      <section class="flex-1 px-20 justify-center mb-2 lg:mb-0 order-1 img-mobile" :class="{ 'lg:order-1': info.side === 'left', 'lg:order-2': info.side === 'right'}">
        <img :src="info.image" class="rounded-full" alt="" />
      </section>
    </section>
  </section>
</template>
<script>
export default {
  props: ["info"],
};
</script>

<style scoped>

  @media (max-width: 991px){
    .img-mobile {
        padding-top: 50px;
    }
  }

</style>